import dateUtils from "@/businesslogic/utils/dateUtils";
import Logger from "js-logger";
import { Anfrage } from "@/model/Anfrage";

export default function vorversicherungsUtils(): any {
  const { getIsoDate, getNow, dateStringToIsoDate, splitDateString, korrektur2902, getNowWithTime } = dateUtils();

  const calculateBeginnDatum = (beginnDatum: Date | undefined): string => {
    Logger.debug("calculateBeginnDatum IN", beginnDatum);

    if (!beginnDatum) {
      return "";
    }

    const today = getNowWithTime();

    if (
      today.getHours() > 11 &&
      beginnDatum.getDate() == today.getDate() &&
      beginnDatum.getMonth() == today.getMonth() &&
      beginnDatum.getFullYear() == today.getFullYear()
    ) {
      beginnDatum.setDate(beginnDatum.getDate() + 1);
    }

    return getIsoDate(beginnDatum);
  };

  const berechneVersicherungsBeginnMin = (_storeData: Anfrage): string => {
    if (_storeData.vorversicherung.antragsart !== "wechsel" && _storeData.vorversicherung.vorhanden !== true) {
      return calculateBeginnDatum(getNow());
    } else {
      return calculateBeginnDatum(versicherungsEndeDatum(_storeData));
    }
  };

  const versicherungsEndeDatum = (_storeData: Anfrage): Date | undefined => {
    const vertragEnde = dateStringToIsoDate(_storeData.vorversicherung.vertragEnde);

    const today = getNow();
    if (!vertragEnde) {
      return undefined;
    }

    const newDate = korrektur2902(vertragEnde);
    return today < newDate ? newDate : today;
  };

  const versicherungsBeginnMinErsterTagDesJahres = (_storeData: Anfrage): boolean => {
    const { monat, tag } = splitDateString(_storeData.tarifinformationen.versicherungsbeginn);

    if (tag === 1 && monat === 1) {
      if (_storeData.tarifinformationen.ablauf !== "einJahr") {
        _storeData.tarifinformationen.ablauf = "";
      }
      return true;
    }
    return false;
  };

  const bereinigeVorversicherung = (vorversicherung: any, gekuendigtVonsetzen: boolean) => {
    if (vorversicherung.antragsart == "aenderung") {
      vorversicherung.gesellschaft = "GEV";
      vorversicherung.gekuendigtVon = "no";
      vorversicherung.vertragEnde = "";
      vorversicherung.versicherungsscheinnummer = "";
    } else if (vorversicherung.antragsart == "wechsel" || vorversicherung.antragsart == "neu") {
      vorversicherung.gesellschaft = "";
      vorversicherung.gekuendigtVon = "";
      vorversicherung.vertragEnde = "";
      vorversicherung.versicherungsscheinnummer = "";
    }
    if (gekuendigtVonsetzen) {
      vorversicherung.gekuendigtVon = "yesByClient";
    }
    if (vorversicherung.antragsart !== "neu") {
      vorversicherung.vorhanden = null;
    }
  };

  return {
    korrektur2902,
    calculateBeginnDatum,
    berechneVersicherungsBeginnMin,
    versicherungsBeginnMinErsterTagDesJahres,
    bereinigeVorversicherung,
  };
}
